<template>
  <v-text-field :value="content" :type="typeValue" :prepend-icon="prependIcon" @input="updateValue" :id="id" ref="inputField" autocomplete="new-password"
                :style="style"
                height="20"
                max-height="20"
                min-height="20"
                @keyup.enter="doKeyupEnter"
                :min="minNumber"
                :max="maxNumber"
                :step="step"
                :disabled="disabled"
                outlined
                @keypress="keypress"/>
</template>

<script>
import uuid from 'uuid/v4'

export default {
  name: 'TextField',
  props: {
    value: {},
    maxWidth: {},
    prependIcon: String,
    type: String,
    min: {},
    max: {},
    step: {},
    disabled: Boolean,
    decimals: {},
    keyupEnter: {}
  },
  data () {
    return {
      id: uuid(),
      content: null,
      typeValue: 'text',
      minNumber: null,
      maxNumber: null,
      stepValue: null,
      decimalNumber: null
    }
  },
  created: function () {
    this.content = this.value
    if (this.type) {
      this.typeValue = this.type
    }
    if (this.min) {
      this.minNumber = Number(this.min)
    }
    if (this.max) {
      this.maxNumber = Number(this.max)
    }
    if (this.step) {
      this.stepValue = Number(this.step)
    }
    if (this.decimals) {
      this.decimalNumber = Number(this.decimals)
    }
  },
  computed: {
    style: function () {
      let style = ''
      if (this.maxWidth) {
        style += 'max-width:' + this.maxWidth + 'px;'
      }
      return style
    }
  },
  methods: {
    updateValue: function (val) {
      this.content = val
      if (this.typeValue === 'number' && this.content !== '' && this.decimalNumber !== null && this.decimalNumber >= 0) {
        let content
        if (this.decimalNumber === 0) {
          content = this.content.match(new RegExp('^\\d+'))
        } else {
          content = this.content.match(new RegExp('^\\d+\\.?\\d{0,' + this.decimalNumber + '}'))
        }
        if (content && content.length > 0) {
          this.content = content[0]
        }
      }
      this.$emit('input', this.content)
    },
    focus: function () {
      this.$nextTick(() => this.$refs.inputField.focus())
    },
    doKeyupEnter: function () {
      if (this.keyupEnter) {
        this.keyupEnter()
      }
    },
    keypress: function (event) {
      if (this.typeValue === 'number') {
        let acceptDecimals = this.decimalNumber !== null && this.decimalNumber >= 0
        if (acceptDecimals) {
          if (event.charCode === 0 || /\d/.test(String.fromCharCode(event.charCode)) || /-/.test(String.fromCharCode(event.charCode)) || /,/.test(String.fromCharCode(event.charCode)) || /\./.test(String.fromCharCode(event.charCode))) {
            return true
          } else {
            event.preventDefault()
          }
        } else {
          if (event.charCode === 0 || /\d/.test(String.fromCharCode(event.charCode)) || /-/.test(String.fromCharCode(event.charCode))) {
            return true
          } else {
            event.preventDefault()
          }
        }
      }
    }
  },
  watch: {
    value (val) {
      this.content = val
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TextField.vue